import Experience from "../Experience";
import { extractFirstSearchResult } from "./arenaNormalizer";
import type { ArenaBlock, ArenaSearchResponse } from "../types/arena";

type ApiClientLike = {
  get: <T = unknown>(endpoint: string) => Promise<T>;
};

export default class DataFetcher {
  endpoint: string | null;
  experience: Experience;
  API: ApiClientLike;

  constructor(endpoint: string | null) {
    this.endpoint = endpoint;
    this.experience = new Experience();
    this.API = this.experience.API;
  }

  async fetchData(): Promise<ArenaBlock> {
    if (!this.endpoint) {
      console.error("Endpoint is undefined");
      return Promise.reject("Endpoint is undefined");
    }

    if (this.endpoint.includes("/search")) {
      return this.API.get<ArenaSearchResponse>(this.endpoint)
        .then((data) => {
          const firstResult = extractFirstSearchResult(data);
          if (!firstResult?.id) {
            throw new Error("Invalid data structure from /search endpoint");
          }
          return this.API.get<ArenaBlock>(`/blocks/${firstResult.id}`);
        })
        .catch((error: unknown) => {
          console.error("Error fetching data from /search endpoint:", error);
          throw error;
        });
    } else if (this.endpoint.includes("/blocks")) {
      return this.API.get<ArenaBlock>(this.endpoint).catch((error: unknown) => {
        console.error("Error fetching data from /blocks endpoint:", error);
        throw error;
      });
    } else {
      return this.API.get<ArenaBlock>(`/blocks/${this.endpoint}`).catch((error: unknown) => {
        console.error("Error fetching data from /blocks endpoint:", error);
        throw error;
      });
    }
  }
}
